const LEAFLET_CSS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
const LEAFLET_JS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';

let loadPromise = null;

const loadStylesheet = (href) => {
  if (document.querySelector(`link[href="${href}"]`)) return;

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = href;
  document.head.appendChild(link);
};

const loadScript = (src, loaderId) =>
  new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[data-loader-id="${loaderId}"]`);
    if (existing) {
      if (existing.getAttribute('data-loaded') === 'true') {
        resolve();
        return;
      }
      existing.addEventListener('load', () => resolve(), { once: true });
      existing.addEventListener('error', reject, { once: true });
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.defer = true;
    script.setAttribute('data-loader-id', loaderId);
    script.onload = () => {
      script.setAttribute('data-loaded', 'true');
      resolve();
    };
    script.onerror = () => reject(new Error(`Nie udało się załadować: ${src}`));
    document.head.appendChild(script);
  });

export const loadLeaflet = () => {
  if (window.L) {
    return Promise.resolve(window.L);
  }

  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = (async () => {
    loadStylesheet(LEAFLET_CSS);

    if (!window.L) {
      await loadScript(LEAFLET_JS, 'leaflet');
    }

    if (!window.L) {
      throw new Error('Nie udało się załadować Leaflet');
    }

    return window.L;
  })().catch((error) => {
    loadPromise = null;
    throw error;
  });

  return loadPromise;
};
